'use client';

import React from 'react';
import { clsx } from 'clsx';
import Link from 'next/link';
import { Icons } from '@shared/ui';
import { useNavigationContext } from './useNavigation';

interface MenuGroupItemProps {
    levelIndex: number;
}

export const MenuGroupItem: React.FC<MenuGroupItemProps> = (props) => {
    const { levelIndex } = props;

    const { state, actions } = useNavigationContext();

    const next = state.navigationGroup[levelIndex];

    if (!next) {
        return null;
    }

    return (
        <ul className="menu-group-list">
            {next.map((item) => (
                <li
                    key={`level-${levelIndex + 1}-menu-group-item-${item.value}`}
                    className={clsx('menu-group-item', {
                        'menu-group-item--active':
                            state.currentNode[levelIndex + 1] === item.value,
                    })}
                    onPointerEnter={() => {
                        if (item.next) {
                            actions.handleUpdateNavigationGroup(
                                levelIndex + 1,
                                item.next,
                                item.value
                            );
                        }
                    }}
                >
                    {item.type === 'none' ? (
                        <span className="menu-group-item-text menu-group-item-text--none">
                            {item.name}
                        </span>
                    ) : (
                        <Link
                            href={item.url || '/'}
                            target={state.openInNewTab ? '_blank' : undefined}
                            rel={state.openInNewTab ? 'noopener noreferrer' : undefined}
                            className="menu-group-item-text"
                        >
                            {item.name}
                        </Link>
                    )}
                    {item.next && item.next.length > 0 && (
                        <button
                            type="button"
                            className="menu-group-item-arrow"
                            onClick={() => {
                                if (item.next) {
                                    actions.handleUpdateNavigationGroup(
                                        levelIndex + 1,
                                        item.next,
                                        item.value
                                    );
                                }
                            }}
                        >
                            <Icons.csr.CaretRight size="1em" weight="bold" />
                        </button>
                    )}
                </li>
            ))}
        </ul>
    );
};
